import { ISymbolParameters } from '@GFTypes/GameStoreTypes/SymbolParameters';

export const SYMBOL_PARAMETERS_DEFAULTS: ISymbolParameters = {
    baseWidth: 300,
    baseHeight: 267,
    baseScale: 1,
    height: 267,
    width: 300,
    scale: 1
};
